import React, { Fragment, Component } from "react";
import MuiTooltip from "@material-ui/core/Tooltip";
import withStyles from "../../styles/withStyles";

let TooltipContent = React.forwardRef((props, ref) => (
  <div {...props} ref={ref}>
    {props.children}
  </div>
));

class Tooltip extends Component {
  constructor(props) {
    super(props);
    this.arrowRef = React.createRef();
  }

  render({ classes, title, children, ...props } = this.props) {
    return (
      <MuiTooltip
        title={
          <Fragment>
            {title}
            <span className={classes.arrow} ref={this.arrowRef} />
          </Fragment>
        }
        classes={{
          tooltip: classes.tooltip,
          popper: classes.popper,
          tooltipPlacementLeft: classes.placementLeft,
          tooltipPlacementRight: classes.placementRight,
          tooltipPlacementTop: classes.placementTop,
          tooltipPlacementBottom: classes.placementBottom
        }}
        PopperProps={{
          popperOptions: {
            modifiers: {
              arrow: {
                enabled: !!this.arrowRef.current,
                element: this.arrowRef.current
              }
            }
          }
        }}
        placement="top"
        {...props}
      >
        <TooltipContent>{children}</TooltipContent>
      </MuiTooltip>
    );
  }
}

let styles = theme => ({
  arrow: {
    color: "black",
    position: "absolute",
    fontSize: 7,
    width: "3em",
    height: "3em",
    "&::before": {
      content: "''",
      margin: "auto",
      display: "block",
      width: 0,
      height: 0,
      borderStyle: "solid"
    }
  },
  popper: arrowGenerator(),
  tooltip: {
    fontSize: "15px",
    padding: "8px 12px",
    backgroundColor: "black",
    position: "relative",
    wordBreak: "break-word",
    borderRadius: "4px"
  },
  placementLeft: {
    margin: "0 12px"
  },
  placementRight: {
    margin: "0 12px"
  },
  placementTop: {
    margin: "12px 0"
  },
  placementBottom: {
    margin: "12px 0"
  }
});

let arrowGenerator = () => ({
  "&[x-placement*='bottom'] $arrow": {
    top: 0,
    left: "calc(50% - 1.5em)",
    marginTop: "-0.9em",
    width: "3em",
    height: "1em",
    "&::before": {
      borderWidth: "0 1em 1em 1em",
      borderColor: "transparent transparent currentcolor transparent"
    }
  },
  "&[x-placement*='top'] $arrow": {
    bottom: 0,
    left: "calc(50% - 1.5em)",
    marginBottom: "-0.9em",
    width: "3em",
    height: "1em",
    "&::before": {
      borderWidth: "1em 1em 0 1em",
      borderColor: "currentcolor transparent transparent transparent"
    }
  },
  "&[x-placement*='right'] $arrow": {
    top: "calc(50% - 1em)",
    left: 0,
    marginLeft: "-0.9em",
    height: "3em",
    width: "1em",
    "&::before": {
      borderWidth: "1em 1em 1em 0",
      borderColor: "transparent currentcolor transparent transparent"
    }
  },
  "&[x-placement*='left'] $arrow": {
    top: "calc(50% - 1em)",
    right: 0,
    marginRight: "-0.9em",
    height: "3em",
    width: "1em",
    "&::before": {
      borderWidth: "1em 0 1em 1em",
      borderColor: "transparent transparent transparent currentcolor"
    }
  }
});

export default withStyles(styles)(Tooltip);
